exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".resized-image__resized-image__3OS6E{background-size:cover;background-position:50%;background-repeat:no-repeat}", "", {"version":3,"sources":["/home/builduser/agent07/work/c8e02a04a4ed599f/src/shared/components/resized-image/src/shared/components/resized-image/resized-image.styl","/home/builduser/agent07/work/c8e02a04a4ed599f/src/shared/components/resized-image/resized-image.styl"],"names":[],"mappings":"AAAA,qCACE,sBAAA,wBACA,2BACA,CCCD","file":"resized-image.styl","sourcesContent":[".resized-image\n  background-size cover\n  background-position center\n  background-repeat no-repeat\n",".resized-image {\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n/*# sourceMappingURL=src/shared/components/resized-image/resized-image.css.map */"],"sourceRoot":""}]);

// exports
exports.locals = {
	"resized-image": "resized-image__resized-image__3OS6E",
	"resizedImage": "resized-image__resized-image__3OS6E"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/shared/components/resized-image/resized-image.styl
// module id = 868
// module chunks = 0 1 2 3 4